'use client';

import { Program, SLPProgramType, StandardLP } from '@/services/types';
import { getItem } from '@/utils/Functions/storageUtils';
import eventTracker from '@/utils/eventTracker';
import { useInView } from 'framer-motion';
import { usePathname, useSearchParams } from 'next/navigation';
import { useContext, useEffect, useRef, useState } from 'react';
import HeroSection from '../landingPage/HeroSection';
import Head from 'next/head';
import { AppContext } from '@/contexts/appcontext';
import * as pixel from '../../utils/fpixel';
import StatsSectionMentorship from '../landingPage/StatsSectionMentorship';
import StatsSectionSPC from '../landingPage/StatsSectionSPC';
import StatsSectionWorkshop from '../landingPage/StatsSectionWorkshop';
import { StandardLpDocument } from '@/gql/graphql';
import { useGraphQL } from '@/utils/useGraphQL';
import { extractImage } from '@/utils/strapiTojs';
const MetaDetails = ({
  productId,
  filteredLearnerData,
  program,
  programType,
  brandLogos
}: {
  productId: string;
  filteredLearnerData: Program | undefined;
  program: StandardLP | undefined;
  programType: SLPProgramType;
  brandLogos: {
    image: Image;
  }[];
}) => {
  const {
    pixelLoaded
  } = useContext<any>(AppContext);
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const {
    data: studentData
  } = useGraphQL(StandardLpDocument, {
    productId: filteredLearnerData?.product_id.toString()
  });
  const studentContent = studentData?.standardLps?.data?.[0]?.attributes?.content;
  const studentDataContent = studentContent?.filter(item => item?.__typename === 'ComponentStndardLpLearnerDetail')[0];
  const studentImages = studentDataContent?.Students?.map(student => {
    return extractImage(student?.StudentImage).src;
  });
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 992 : false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 992);
      };
      window.addEventListener('resize', handleResize);

      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  const sectionRef = useRef(null);
  const sectionInView = useInView(sectionRef, {
    amount: 0
  });
  useEffect(() => {
    if (sectionInView) {
      document.querySelector('.section__navbar')?.classList.remove('section__navbar--colored');
    } else {
      document.querySelector('.section__navbar')?.classList.add('section__navbar--colored');
    }
  }, [sectionInView]);
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('config', process.env.NEXT_PUBLIC_GA_ID, {
        event_label: 'Standard Landing Page Viewed',
        page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}?${searchParams.toString()}`
      });
      window.webengage.onReady(() => {
        window.webengage.track('Page Viewed', {
          page_url: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}?${searchParams.toString()}`,
          program_name: getItem('Program Name'),
          product_id: productId
        });
      });
    }
    eventTracker.slPageViewed({
      pageName: 'Standard landing page: slp',
      pageURL: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}?${searchParams.toString()}`,
      programType: (getItem('Program Type') as string) ?? ''
    });
  }, []);
  useEffect(() => {
    if (!pixelLoaded) return;
    pixel.pageview();
  }, [pixelLoaded]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="MetaDetails.tsx">
        <meta property="og:image" content="https://assets-global.website-files.com/624194472db3153002097068/624ace96c9f9ab0aed097ba6_GS%20Logo%20(5)%201.svg" data-sentry-element="meta" data-sentry-source-file="MetaDetails.tsx" />
      </Head>
      <div className="meta-details" ref={sectionRef}>
        {' '}
        <HeroSection learnerData={filteredLearnerData} program={program} programType={programType} isMobile={isMobile} data-sentry-element="HeroSection" data-sentry-source-file="MetaDetails.tsx" />
        {(() => {
        switch (programType) {
          case SLPProgramType.MENTORSHIP:
            return <StatsSectionMentorship brandLogos={brandLogos} isMobile={isMobile} />;
          case SLPProgramType.SELFPACED:
            return <StatsSectionSPC brandLogos={brandLogos} filteredLearnerData={filteredLearnerData} studentImages={studentImages ?? []} isMobile={isMobile} />;
          case SLPProgramType.WORKSHOP:
            return <StatsSectionWorkshop brandLogos={brandLogos} isMobile={isMobile} />;
          // default:
          //   return <StatsSection brandLogos={brandLogos} />;
        }
      })()}
      </div>
    </>;
};
export default MetaDetails;